import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import styles from './Breadcrumb.module.css';

/**
 * 경로 표시.
 * 같은 마크업과 스타일이 상세 · 고객지원 · 약관 세 곳에 복제돼 있어
 * 크기를 한 번 바꿀 때마다 세 파일을 고쳐야 했다.
 *
 * @param {{to?: string, label: string}} parent  상위 경로 (기본: 홈)
 * @param {string} current  현재 위치 — 링크가 아닌 텍스트
 * @param {string} className  페이지별 여백 보정용 (모바일에서 컨테이너 패딩이 사라지는 경우 등)
 */
export default function Breadcrumb({ parent = { to: '/', label: '홈' }, current, className = '' }) {
  return (
    <nav className={`${styles.breadcrumb} ${className}`.trim()} aria-label="현재 위치">
      <Link to={parent.to}>{parent.label}</Link>
      <ChevronRight size={14} strokeWidth={2} aria-hidden="true" />
      <span>{current}</span>
    </nav>
  );
}
